import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class AbstractHistoryTableService {
  abstract getHistory(
    id: string,
    searchValue: string | undefined,
    filters: string | undefined,
    sort: string | undefined
  ): Observable<object[]>;
  abstract exportHistory(
    id: string,
    searchValue: string | undefined,
    filters: string | undefined,
    sort: string | undefined
  ): Observable<ArrayBuffer>;
  abstract historySuggestion(
    id: string,
    search: { field: string; value: string }
  ): Observable<string[]>;
  abstract getEventTypes(): Observable<{ label: string; value: string }[]>;
}
